module.exports = __webpack_public_path__ + "img/after3-Recovered.4b520bad.webp";